import {
  Accordion,
  AccordionDetails,
  AccordionItem,
  AccordionSummary,
  AccordionTitle
} from "@deere/fuel-react";
import {Container} from "@mui/material";
import React, { useEffect } from "react";
import "../../App.css";
import {
  COMPETITOR_INFO,
  CUSTOMER_AND_DEAL_INFO,
  DLR_COST_MARGIN,
  LEASE, MACHINE_SPEC,
  RETAIL_NOTE,
  SPREAD_MARGIN_CALC,
} from "../../utilities/constants.js";
import ConnectedTransactionUtilityBar from "../TransactionUtility/connected-transaction-utility-bar";
import ToastUtility from "../Utility/toast-utility";
import ConnectedCompetitorInformation from "./connected-competitor-information";
import ConnectedDealerCostAndMarginDetails from "./connected-dealer-cost-and-margin-details.js";
import ConnectedLeaseAccordion from "./connected-lease-accordion.js";
import ConnectedRetailAccordion from "./connected-retail-accordion";
import ConnectedSpreadAndMarginAccordion from "./connected-spread-and-margin-accordion";
import ConnectedTransactionDetails from "./connected-transaction-details.js";
import ConnectedMachineSpecAccordion from "./connected-machine-spec-accordion.js"

function Transaction(props) {
  const [showToast, setShowToast] = React.useState("none");

  const scrollToTargetAdjusted = (targetElement) => {
    const headerOffset = 80;
    const elementPosition = document
        .getElementById(targetElement)
        .getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    if (props.selectedAccordion) {
      if (
          props.selectedAccordion === CUSTOMER_AND_DEAL_INFO.title &&
          document.getElementById("connectedTransactionDetails")
      ) {
        scrollToTargetAdjusted("connectedTransactionDetails");
      } else if (
          props.selectedAccordion === COMPETITOR_INFO.title &&
          document.getElementById("machineAccordionTitle")
      ) {
        scrollToTargetAdjusted("machineAccordionTitle");
      } else if (
          props.selectedAccordion === DLR_COST_MARGIN.title &&
          document.getElementById("costAndMarginTitle")
      ) {
        scrollToTargetAdjusted("costAndMarginTitle");
      } else if (
          props.selectedAccordion === MACHINE_SPEC.title &&
          document.getElementById("machineSpecAccordionTitle")
      ) {
        scrollToTargetAdjusted("machineSpecAccordionTitle");
      } else if (
          props.selectedAccordion === SPREAD_MARGIN_CALC.title &&
          document.getElementById("spreadAndMarginAccordionTitle")
      ) {
        scrollToTargetAdjusted("spreadAndMarginAccordionTitle");
      } else if (
          props.selectedAccordion === LEASE.title &&
          document.getElementById("leasePaymentAccordionTitle")
      ) {
        scrollToTargetAdjusted("leasePaymentAccordionTitle");
      } else if (
          props.selectedAccordion === RETAIL_NOTE.title &&
          document.getElementById("retailPaymentAccordionTitle")
      ) {
        scrollToTargetAdjusted("retailPaymentAccordionTitle");
      }
    }
  }, [props.selectedAccordion]);

  useEffect(() => {
    setShowToast("inline");
    setTimeout(() => {
      setShowToast("none");
    }, "8000");
  }, [props.errorFields]);
  const handleClose = () => {
    setShowToast("none");
    props.setCreateTransactionResponseObj(null);
  };
  return (
      <div>
        <ConnectedTransactionUtilityBar />
        {props.errorFlag === true && (
            <div>
              {props.createTransactionResponse ? (
                  <ToastUtility
                      toastDisplay={showToast}
                      toastVariant="error"
                      handleClose={handleClose}
                      toastMessage={
                        props.createTransactionResponse &&
                        props.createTransactionResponse.transactions[0].errors[0]
                            .message
                      }
                  />
              ) : (
                  <ToastUtility
                      toastDisplay={showToast}
                      handleClose={handleClose}
                      toastVariant="error"
                      toastMessage={props.texts.PLS_ETR_REQ_FIELDS}
                  />
              )}
            </div>
        )}
        <div style={{ paddingTop: "1rem" }}>
          <Container
              className="container"
              style={{ fontWeight: "bold", marginBottom: "60px" }}
          >
            <div
                style={{ paddingBottom: "0.5rem" }}
                className="uxf-main-container"
                id={"connectedTransactionDetails"}
            >
              <ConnectedTransactionDetails />
            </div>
            <Accordion id="spacedGroup" spaced={true}>
              <AccordionItem
                  id={"machineCompetitorItem"}
                  rightAligned
                  defaultExpanded={true}
              >
                <AccordionSummary>
                  <AccordionTitle id={"machineAccordionTitle"}>
                    {props.texts.COMPETITOR_INFO}
                  </AccordionTitle>
                </AccordionSummary>
                <AccordionDetails>
                  <ConnectedCompetitorInformation />
                </AccordionDetails>
              </AccordionItem>
              {LEASE.title === props.paymentMethod && (
                  <AccordionItem
                      id={"leasePaymentAccordion"}
                      rightAligned
                      defaultExpanded={true}
                  >
                    <AccordionSummary>
                      <AccordionTitle id={"leasePaymentAccordionTitle"}>
                        {props.texts.LEASE}
                      </AccordionTitle>
                    </AccordionSummary>
                    <AccordionDetails>
                      <ConnectedLeaseAccordion />
                    </AccordionDetails>
                  </AccordionItem>
              )}
              {RETAIL_NOTE.title === props.paymentMethod && (
                  <AccordionItem
                      id={"retailPaymentAccordion"}
                      rightAligned
                      defaultExpanded={true}
                  >
                    <AccordionSummary>
                      <AccordionTitle id={"retailPaymentAccordionTitle"}>
                        {props.texts.RETAIL_NOTE +
                        " " +
                        props.texts.RETAIL_NOTE_DES}
                      </AccordionTitle>
                    </AccordionSummary>
                    <AccordionDetails>
                      <ConnectedRetailAccordion />
                    </AccordionDetails>
                  </AccordionItem>
              )}
              <AccordionItem
                  id={"dealerCostAndMarginItem"}
                  rightAligned
                  defaultExpanded={true}
              >
                <AccordionSummary>
                  <AccordionTitle id={"costAndMarginTitle"}>
                    {props.texts.DLR_COST_MARGIN}
                  </AccordionTitle>
                </AccordionSummary>
                <AccordionDetails>
                  <ConnectedDealerCostAndMarginDetails />
                </AccordionDetails>
              </AccordionItem>
              <AccordionItem
                  id={"machineSpecAccordion"}
                  rightAligned
                  defaultExpanded={true}
              >
                <AccordionSummary>
                  <AccordionTitle id={"machineSpecAccordionTitle"}>
                    {props.texts.MACHINE_SPEC}
                  </AccordionTitle>
                </AccordionSummary>
                <AccordionDetails>
                  <ConnectedMachineSpecAccordion />
                </AccordionDetails>
              </AccordionItem>
              <AccordionItem
                  id={"spreadAndMarginAccordion"}
                  rightAligned
                  defaultExpanded={true}
              >
                <AccordionSummary>
                  <AccordionTitle id={"spreadAndMarginAccordionTitle"}>
                    {props.texts.SPREAD_MARGIN_CALC}
                  </AccordionTitle>
                </AccordionSummary>
                <AccordionDetails>
                  <ConnectedSpreadAndMarginAccordion />
                </AccordionDetails>
              </AccordionItem>
            </Accordion>
          </Container>
        </div>
      </div>
  );
}

export default Transaction;